import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Avatar, Box, Button, Paper, Typography } from '@mui/material';
import { PersonAdd } from '@mui/icons-material';
import { UserPublicProfile } from '../services/buddyService';

function initials(name: string) {
  return name.split(' ').filter(Boolean).slice(0, 2).map(w => w[0].toUpperCase()).join('');
}

/** One diver in a community's member list, with a Follow button. Shared by the region and country pages. */
const DiverRow: React.FC<{
  diver: UserPublicProfile;
  isSelf: boolean;
  followed: boolean;
  onFollow: (diver: UserPublicProfile) => void;
}> = ({ diver, isSelf, followed, onFollow }) => (
  <Paper variant="outlined" sx={{ p: 1.5, display: 'flex', alignItems: 'center', gap: 1.5 }}>
    <Avatar
      component={RouterLink}
      to={`/u/${diver.userId}`}
      src={diver.profilePhotoUrl ?? undefined}
      sx={{ width: 40, height: 40, bgcolor: 'primary.main', fontWeight: 700, textDecoration: 'none' }}
    >
      {!diver.profilePhotoUrl && (initials(diver.displayName) || '?')}
    </Avatar>
    <Box sx={{ flexGrow: 1, minWidth: 0 }}>
      <Typography variant="subtitle2" noWrap sx={{ fontWeight: 700 }}>{diver.displayName}{isSelf ? ' (you)' : ''}</Typography>
      <Typography variant="caption" color="text.secondary" noWrap sx={{ display: 'block' }}>
        {[diver.homeSiteName, diver.diveCountLabel].filter(Boolean).join(' · ')}
      </Typography>
    </Box>
    {!isSelf && (
      <Button size="small" variant={followed ? 'outlined' : 'contained'} disabled={followed} startIcon={<PersonAdd />} onClick={() => onFollow(diver)}>
        {followed ? 'Following' : 'Follow'}
      </Button>
    )}
  </Paper>
);

export default DiverRow;
